// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import {
    Grid,
    Box,
    Typography,
    Button,
    IconButton,
    CircularProgress,
    Modal,
    FormControlLabel,
    Switch,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { CustomTextField } from "components";
import { UserService } from "services/UserService";
import { useAuth } from "context/authContext";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { useAppData } from "context/AppContext";
import { Timestamp } from "firebase/firestore";

type DocumentModalProps = {
    filePreview: string | null;
    open: boolean;
    onClose: () => void;
};

const DocumentModal = (props: DocumentModalProps) => {
    const { filePreview, open, onClose } = props;
    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%", // Ensure the modal takes full height of the screen
                }}
            >
                <Box
                    sx={{
                        width: 700,
                        maxHeight: "80vh", // Restricting the maximum height
                        overflowY: "auto", // Enabling vertical scrolling
                        bgcolor: "background.paper",
                        borderRadius: "8px",
                        outline: "none",
                        position: "relative",
                        margin: "auto", // Centers the modal horizontally
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: 2,
                            borderBottom: "1px solid #ccc",
                        }}
                    >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <InsertDriveFileIcon sx={{ mr: 1 }} />
                            <Typography variant="h6">Insurance_2024</Typography>
                        </Box>
                        <IconButton onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Box sx={{ padding: 4 }}>
                        {filePreview ? (
                            <img
                                src={filePreview}
                                alt="Document Preview"
                                style={{ width: "100%", height: "auto" }}
                            />
                        ) : (
                            <Typography>No File Available</Typography>
                        )}
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
};

const LicenseUploaded = ({
    licenseData,
    setLicenseData,
    onChange = () => { },
    setShowIcons,
}: any) => {
    const { currentUser } = useAuth();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [verified, setVerified] = useState(true);
    const [filePreview, setFilePreview] = useState<string | null>(
        licenseData.licenseImageUrl || null
    );

    const fileInputRef = useRef<HTMLInputElement>(null);

    const { setUser, user } = useAppData();

    // Update parent state when input fields change
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setLicenseData((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleUploadLicense = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleLicenseVerification = () => {
        setUser((prevUser) => {
            if (!prevUser) return null;
            return {
                ...prevUser,
                isLicenseVerified: !prevUser.isLicenseVerified,
            };
        });
    };
    return (
        <>
            <DocumentModal
                filePreview={
                    "https://firebasestorage.googleapis.com/v0/b/affekti---project.appspot.com/o/files%2Ffd4cc0bd-4b5a-41f4-8f7d-81c3fe4ab63b?alt=media&token=8790c05d-39ac-4c44-8101-3bac014f8ec3"
                }
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
            <div style={{ display: "flex", flexDirection: "row" }}>
                <Grid
                    display={"flex"}
                    gap={3} // Reduced gap for smaller size
                    flexDirection={"column"}
                    p={{ xs: 1, md: 3, pr: 0 }} // Reduced padding for smaller size
                    mt={{ xs: 2, md: 0 }} // Adjusted margin top for smaller size
                >
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        {" "}
                        {/* Reduced grid size */}
                        <Typography
                            variant="h6"
                            gutterBottom
                            sx={{
                                fontWeight: 700,
                                fontSize: "16px", // Reduced font size
                                color: "#000000",
                                marginBottom: 1, // Reduced margin bottom
                            }}
                        >
                            Please upload your license
                        </Typography>
                        <Box sx={styleSheet.constainer}>
                            {!filePreview ? (
                                <Box sx={styleSheet.downContainer}>
                                    <CloudUploadIcon sx={{ fontSize: 35, color: "#666" }} />{" "}
                                    {/* Reduced icon size */}
                                    <Typography variant="body1" sx={{ marginTop: 0.5 }}>
                                        {" "}
                                        {/* Reduced margin top */}
                                        Drag & Drop or choose file to upload
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{ color: "#666", marginTop: 0.5 }}
                                    >
                                        {" "}
                                        {/* Reduced margin top */}
                                        Select an Image
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            marginTop: 1, // Reduced margin top
                                            backgroundColor: "#233F91",
                                            color: "#fff",
                                            borderRadius: "15px",
                                            width: "180px", // Reduced button width
                                            height: "50px", // Reduced button height
                                            mt: 1, // Reduced margin top
                                        }}
                                        onClick={handleUploadLicense}
                                    >

                                        {isLoading ? <CircularProgress size={20} /> : "Browse File"}{" "}
                                        {/* Reduced progress size */}
                                    </Button>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        ref={fileInputRef}
                                        style={{ display: "none" }}
                                        onChange={(event) => { }}
                                    />
                                </Box>
                            ) : (
                                <Grid display={"flex"} alignItems={"center"} flex={1}>
                                    <Box
                                        sx={{
                                            flexGrow: 1,
                                            display: "flex",
                                            gap: 1,
                                            alignItems: "center",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                // width: "500px", // Reduced width
                                                // height: "45px", // Reduced height
                                                // border: "2px dashed #ccc",
                                                // borderRadius: "9px",
                                                // display: "flex",
                                                // alignItems: "center",
                                                width: "520px",
                                                height: "51px",
                                                border: "2px dashed #ccc",
                                                borderRadius: "9px",
                                                display: "flex",
                                                alignItems: "center",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            <Typography
                                                ml={2}
                                                fontSize={"16px"} // Reduced font size
                                                fontWeight={700}
                                                color={"#595959"}
                                            >
                                                {filePreview}
                                            </Typography>
                                        </Box>
                                        <IconButton
                                            onClick={() => setFilePreview(null)}
                                            sx={{ color: "#FF0000" }}
                                        >
                                            {/* <img src="assets/icons/iconDelete.png" alt="delete" /> */}
                                        </IconButton>
                                        <div onClick={() => setIsModalOpen(true)} style={{ color: "#233F91", cursor: "pointer" }}>View</div>
                                    </Box>
                                </Grid>
                            )}
                        </Box>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={5} // Reduced grid size
                        display={"flex"}
                        gap={1}
                        flexDirection={"column"}
                    >
                        <label htmlFor="licenseExpiration" style={styleSheet.labelText}>
                            License Expiration
                        </label>
                        <Grid display={"flex"} gap={1} alignItems={"center"} flex={1} >
                            {" "}
                            {/* Reduced gap */}
                            <Box sx={{ flexGrow: 1, }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        views={["day", "month", "year"]}
                                        value={user?.licenseExpiration ? dayjs(user.licenseExpiration) : null}
                                        onChange={() => { }}
                                        format="MM/DD/YYYY"
                                        // disableFuture={false}
                                        disablePast
                                        sx={styleSheet.datePicker}
                                    />
                                </LocalizationProvider>
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={5} // Reduced grid size
                        display={"flex"}
                        gap={1}
                        flexDirection={"column"}
                    >
                        <label htmlFor="typeOfLicense" style={styleSheet.labelText}>
                            Type of License
                        </label>
                        <Grid display={"flex"} gap={1} alignItems={"center"} flex={1}>
                            {" "}
                            {/* Reduced gap */}
                            <Box sx={{ flexGrow: 1 }}>
                                <CustomTextField
                                    name="typeOfLicense"
                                    sx={styleSheet.customField}
                                    value={user?.typeOfLicense || ""}
                                    onChange={handleChange}
                                />
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={5} // Reduced grid size
                        display={"flex"}
                        gap={1}
                        flexDirection={"column"}
                    >
                        <label htmlFor="licenseNumber" style={styleSheet.labelText}>
                            License Number
                        </label>
                        <Box sx={{ flexGrow: 1 }}>
                            <CustomTextField
                                name="licenseNumber"
                                type="number"
                                sx={styleSheet.customField}
                                value={user?.licenseNumber || ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={5} // Reduced grid size
                        display={"flex"}
                        gap={1}
                        flexDirection={"column"}
                    >
                        <label htmlFor="stateofLicensure" style={styleSheet.labelText}>
                            State of Licensure
                        </label>
                        <Box sx={{ flexGrow: 1 }}>
                            <CustomTextField
                                name="stateofLicensure"
                                sx={styleSheet.customField}
                                value={user?.stateofLicensure || ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 54 }}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={user?.isLicenseVerified}
                                onChange={handleLicenseVerification}
                                color="primary"
                            />
                        }
                        label="Verified"
                        labelPlacement="end"
                    />
                </Box>
            </div>
        </>
    );
};

export default LicenseUploaded;

const styleSheet = {
    labelText: {
        fontWeight: 400,
        fontSize: "17px",
        color: "#000000",
    },
    customField: {
        width: "100%",
        maxWidth: "599px",
    },
    downContainer: {
        border: "2px dashed #ccc",
        width: { xs: "295px", md: "563px" },
        height: "276px",
        borderRadius: "8px",
        padding: "16px",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        backgroundColor: "#f9f9f9",
    },
    constainer: {
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        width: "100%",
        maxWidth: "654px",
    },
    datePicker: {
        width: { xs: "100%", md: "599px" },
        "& .MuiInputBase-root": {
            backgroundColor: "transparent",
            borderRadius: "9px",
            height: "50px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#C9C9C9", // Regular border color
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#C9C9C9",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#C9C9C9",
            boxShadow: "0px 0px 0px 4px #C9C9C9",
        },
        "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            borderColor: "#C9C9C9", // Override the red border color when in error state
        },
        "& .MuiSvgIcon-root": {
            color: "#707070",
        },
    },
};
